import { sharedApi } from "./authenticatedAxios";
import { responseDataHandler } from "./responseHandler";

export const getUserKycSession = () =>
  sharedApi.post("/user/kyc/session").then(({ data }) => responseDataHandler(data));
